import React from 'react';
export function PainPoints() {
  return <section className="w-full overflow-hidden" data-id="element-159" data-mp="3gd1owehj5v0z">
      <img src="https://cdn.magicpatterns.com/uploads/onWqU4kq3xngYBfEJ21rXw/ChatGPT_Image_6_ago_2026,_22_36_24.webp" alt="El amor no es suficiente para sanar un sistema familiar" className="w-full h-auto block" data-id="element-160" data-mp="2lnu26to0xz3m" />
    </section>;
}